<template>
  <section>
    <div id="subHeader">
      <h1>Calendário Fiscal</h1>
      <h2>Evite Coimas</h2>
    </div>
    <div class="container-fluid" id="main">
      <div class="row">

        <div class="calendar p-3 col-md-12 col-xl-6">
          <div class="card-bg p-3">
            <div class="ca-header">
              <h2 class="month">{{ date.format('MMMM') }}</h2>
              <small class="year">{{ date.format('Y') }}</small>
              <a @click.prevent="previous" class="btn-prev fontawesome-angle-left">
                <img alt="" src="/images/esquerda.png">
              </a>
              <a @click.next="next" class="btn-next fontawesome-angle-right">
                <img alt="" src="/images/esquerda.png">
              </a>
            </div>
            <hr class="pb-3">
            <table>
              <thead>
              <tr>
                <td v-for="weekday in moment.weekdays(true)">{{ weekday.substring(0, 3) }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="week in calendar">
                <td :class="{'day-filler': day.filler, active: day.active, event: day.events.length}"
                    v-for="day in week">
                  <a @click.prevent="setDayEvents(day.key)" href="javascript:void(0)">
                    {{ day.day }}
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="p-0" id="list" v-if="dayEvents.length">
            <div class="card-bg">
              <section>
                <div class="day-event p-3" v-for="event in dayEvents">
                  <div class="card">
                    <div class="card-header text-center">
                      {{ event.title }}
                      <br>{{ moment(event.start).format('YYYY-MM-DD') }}
                    </div>
                    <div class="card-body" v-html="event.description"></div>
                  </div>
                </div>
              </section>
            </div>
          </div>

        </div>

        <div class="col-md-12 col-xl-6 p-3" id="list-full">
          <div class="card-bg">
            <h1 class="text-center p-4">Este Mês</h1>
            <hr>
            <section>
              <div class="card" v-if="!events.length">
                <div class="card-body text-center text-center">
                  Sem Eventos
                </div>
              </div>
              <template v-else>
                <div class="card" v-for="event in events">
                  <div class="card-header text-center">
                    {{ event.title }}
                    <br>{{ moment(event.start).format('YYYY-MM-DD') }}
                  </div>
                  <div class="card-body" v-html="event.description"></div>
                </div>
              </template>
            </section>
            <button class="btn w-100" onclick="window.toggleFullList()">Ver Mais</button>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Calendario",
  metaInfo: {
    title: 'Calendario',
  },
  data() {
    return {
      date: moment(),
      calendar: [],
      calendarTemp: [[], [], [], [], [], []],
      events: [],
      dayEvents: []
    }
  },
  methods: {
    previous() {
      let date = this.date.clone().subtract(1, 'months');
      this.$router.push({params: {year: date.year(), month: (date.month() + 1), day: 1}});
    },
    next() {
      let date = this.date.clone().add(1, 'months');
      this.$router.push({params: {year: date.year(), month: (date.month() + 1), day: 1}});
    },
    setCalendar(to) {
      let date = this.date;
      let params = to.params;
      // set year
      if (params.year) {
        date.date(1);
        date.month(1);
        date.year(params.year);
      }
      // set month
      if (params.month) {
        date.date(1);
        date.month(params.month - 1);
      }
      // set day
      if (params.day) {
        date.date(params.day);
      }
      // set calendar
      let daysOfMonth = date.daysInMonth();
      let start = date.clone().startOf('month').day() || 7;
      let end = date.clone().endOf('month').day();
      let lastMonth = date.clone().subtract(1, 'month');
      let lastMonthDays = lastMonth.daysInMonth();
      let currentWeek = 0;
      let currentDay = start;
      let calendar = [[], [], [], [], [], []];
      // begining
      for (let i = 1; i < start; i++) {
        calendar[currentWeek].push({day: (lastMonthDays - i + 1), filler: true, events: []});
      }
      //days
      for (let i = 1; i <= daysOfMonth; i++) {
        calendar[currentWeek].push({
          day: i,
          active: i === date.date(),
          key: '_' + Math.random().toString(36).substr(2, 9),
          events: []
        });
        currentDay++;
        if (currentDay > 7) {
          currentDay = 1;
          currentWeek++;
        }
      }
      // begining
      for (let i = 7; i > end; i--) {
        calendar[currentWeek].push({day: (7 - i + 1), filler: true, events: []});
      }
      this.calendar = calendar;
      this.date = this.date; // force update
      axios.post('/calendario', {date: this.date})
          .then(rsp => {
            this.events = rsp.data;
            this.populateCalendarEvents();
          });
    },
    limitEvents() {
      var full_list_elems = $('#list-full section .card:nth-child(2)').nextAll('.card');
      window.toggleFullList = () => full_list_elems.slideToggle('fast');
      full_list_elems.hide();
    },
    setDayEvents(key) {
      this.calendar.forEach(week => {
        week.forEach(c => {
          if (c.key === key) {
            return this.dayEvents = c.events
          }
        })
      })
    },
    populateCalendarEvents() {
      this.events.forEach(e => {
        let dayStart = moment(e.start).date();
        let dayEnd = moment(e.start).date();
        this.calendar.forEach(week => {
          week.forEach(c => {
            if (
                c.key
                && c.day >= dayStart
                && c.day <= dayEnd
            ) {
              c.events.push(e)
            }
          })
        })
      });
    }
  },
  updated() {
    this.limitEvents();
  },
  mounted() {
    this.$parent.image = '/images/calendario_fiscao.jpg';
  },
  beforeRouteUpdate(to, from, next) {
    this.calendar = [[], [], [], [], [], []];
    this.setCalendar(to);
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.setCalendar(to));
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

h2 {
  font-size: 22px;
  margin: 4px 0;
}

h3 {
  font-size: 24px;
  margin: 5px 0;
}

table {
  border-spacing: 0;
  width: 100%;
}

.calendar {
  text-align: center;
}

.calendar .ca-header {
  position: relative;
}

.calendar h2 {
  text-transform: uppercase;
}

.calendar thead {
  font-weight: 600;
  text-transform: uppercase;
}

.calendar tbody {
  color: #7c8a95;
}

.calendar tbody td + .event:hover,
.calendar tbody td.active {
  background: #A7BAB2;
  color: #000;
}

.calendar tbody td + .event:hover:after,
.calendar tbody td.active:after {
  background: #000;
}

.calendar td {
  border: 2px solid transparent;
  height: 64px;
  text-align: center;
  width: 64px;
  line-height: 64px;
  user-select: none;

  > a, > a:focus, > a:visited {
    color: inherit;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
  }

}

.current-day {
  background: #A7BAB2;
  color: #000;
}

.event {
  position: relative;
  cursor: pointer;
}

.event:after {
  background: #A7BAB2;
  bottom: 8px;
  display: block;
  content: '';
  height: 8px;
  left: 50%;
  margin: -4px 0 0 -4px;
  position: absolute;
  width: 8px;
  border-radius: 50%;
}

.event.current-day:after {
  background: #f9f9f9;
}

.btn-prev,
.btn-next {
  color: #cbd1d2;
  height: 32px;
  font-size: 29px;
  line-height: 29px;
  margin: -16px;
  position: absolute;
  top: 50%;
  width: 32px;
}

.btn-prev:hover,
.btn-next:hover {
  background: #cbd1d2;
  color: #000;

  img {
    filter: invert(0%);
  }
}

.btn-prev img,
.btn-next img {
  height: 100%;
  width: auto;
  object-fit: contain;
  filter: invert(100%);
  position: absolute;
  right: 0;
}

.btn-next img {
  transform: scaleX(-1);
}

.btn-prev {
  left: 30px;
}

.btn-next {
  right: 35px;
}

.card-bg {
  background: rgba(18, 24, 27, 0.97);
}

.close {
  color: #A4AAAB;
  margin-top: -15px;
  margin-right: 10px;
  float: right;
}

.month small {
  font-size: 60%;
}

#list .day-event {
  background-color: transparent;
  width: 100%;
}

#list .card,
#list-full .card {
  background-color: transparent;
}

#list-full > .card-bg > button {
  background: rgba(0, 0, 0, .35);
  color: #fff;
}

.day-filler {
  background: rgba(0, 0, 0, .25);
}
</style>